import { configureStore } from "@reduxjs/toolkit";
import fnolInstanceReducer from "slices/fnolInstanceSlice";
import fnolInstanceMetaDataReducer from "slices/fnolInstanceMetaDataSlice";
import fnolOnPropertyChangeReducer from "slices/fnolOnPropertyChangeSlice";
import customerThemeReducer from "slices/customerThemeSlice";
import fnolSubmissionReducer from "slices/fnolSubmissionSlice";

const store = configureStore({
  reducer: {
    fnolInstance: fnolInstanceReducer,
    fnolInstanceMetaData: fnolInstanceMetaDataReducer,
    fnolOnPropertyChangeData: fnolOnPropertyChangeReducer,
    customerTheme: customerThemeReducer,
    fnolSubmission: fnolSubmissionReducer,
  },
});

export default store;
